import { DocFlowWidgetStatus } from '../../DocFlow.constants'
import { isDocFlowWidgetStatusCompleted } from '../../DocFlow.utils.widgets'
import { DocFlowMappingProcessCell } from '../../DocFlowMapping'

export function getUpdateFileProcessPayload(processData) {
  return {
    ...(processData[DocFlowMappingProcessCell.AwsProcessFinishedAt]
      ? {
          [DocFlowMappingProcessCell.SplittingPhase]:
            DocFlowWidgetStatus.InProgress,
        }
      : null),
    [DocFlowMappingProcessCell.SelectTypePhase]: DocFlowWidgetStatus.Completed,
  }
}

export function isDocFlowMappingWidgetMultiplyingDone({ isSplitting, status }) {
  return isDocFlowWidgetStatusCompleted(status) && !isSplitting
}

export function isDocFlowMappingWidgetSplittingDone({
  isSplitting,
  processData,
}) {
  return (
    isSplitting &&
    processData?.[DocFlowMappingProcessCell.AwsProcessFinishedAt] &&
    isDocFlowWidgetStatusCompleted(
      processData?.[DocFlowMappingProcessCell.SelectTypePhase]
    )
  )
}

export function isDocFlowMappingWidgetDone({
  isMultiplyingDone,
  isSplittingTypeDone,
}) {
  return isMultiplyingDone || isSplittingTypeDone
}

export function isDocFlowMappingWidgetTypeInProcess({
  isSplitting,
  processData,
}) {
  return (
    (processData?.[DocFlowMappingProcessCell.AwsProcessScheduled] ||
      processData?.[DocFlowMappingProcessCell.AwsProcessStartedAt]) &&
    isSplitting &&
    !processData?.[DocFlowMappingProcessCell.AwsProcessFinishedAt]
  )
}
